import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import packageJson from "../../../package.json";
import ArrivaLogo from "../../assets/img/arriva_logo.png";
import { localeNames, supportedLocales } from "../../config/locales.js";
import { selectUser } from "../../store/selectors.js";
import { selectLocale } from "../../store/selectors.js";
import { updateLocale } from "../../store/thunks.js";
import { localeFlags } from "../../utils/utils.js";

const styles = {
  navigationContainer: {
    width: "100%",
    backgroundColor: "#00becd",
  },
  containerFluid: {
    paddingLeft: " 16px",
    paddingRight: "16px",
  },
};
const messages = {
  logout: {
    id: "components.Header.logout",
    description: "Header dropdown-menu logout option.",
    defaultMessage: "Logout",
  },
  languages: {
    id: "components.Header.languages",
    description: "Header dropdown-menu languages sub-menu header.",
    defaultMessage: "Languages",
  },
  support: {
    id: "components.Header.support",
    description: "Header drop-down menu support menu item label.",
    defaultMessage: "Support",
  },
};

const Header = () => {
  const dispatch = useDispatch();
  const currentLocale = useSelector(selectLocale);
  const user = useSelector(selectUser);
  const { formatMessage } = useIntl();

  const handleLocaleChange = (locale) => {
    dispatch(updateLocale(locale));
  };

  return (
    <Navbar
      expand={false}
      variant="dark"
      className="mb-3"
      style={styles.navigationContainer}
    >
      <Container fluid style={styles.containerFluid}>
        <Navbar.Brand href="#">
          <img src={ArrivaLogo} alt="Arriva" />
        </Navbar.Brand>
        <Navbar.Text className="ms-auto me-3" id="app-version">
          Versienummer: {packageJson.version}
        </Navbar.Text>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" color={"red"} />
        <Navbar.Offcanvas id={`offcanvas-navbar-`} placement="end">
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              <Nav.Link href="/support" style={{ color: "rgba(0,0,0,0.7)" }}>
                {formatMessage(messages.support)}
              </Nav.Link>
              {user && (
                <Nav.Link href="/logout" style={{ color: "rgba(0,0,0,0.7)" }}>
                  {formatMessage(messages.logout)}
                </Nav.Link>
              )}
              <NavDropdown
                id="nav-dropdown"
                title={formatMessage(messages.languages)}
              >
                {supportedLocales.map((locale) => (
                  <NavDropdown.Item
                    key={locale}
                    active={currentLocale === locale}
                    onClick={() => handleLocaleChange(locale)}
                  >
                    <img src={localeFlags[locale]} alt={localeNames[locale]} />
                    {` ${localeNames[locale]}`}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default Header;
